var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("记录日志内容")]),
      _c("p", { staticClass: "d2-mt-0" }, [
        _vm._v("在下方输入你要记录的日志，然后点击记录按钮")
      ]),
      _c("el-input", {
        staticClass: "d2-mr-10",
        staticStyle: { width: "200px" },
        attrs: { placeholder: "日志内容" },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
        [_vm._v("记录")]
      ),
      _c("p", [
        _vm._v(
          '此信息已经被记录在日志页面，并在页面右上"日志按钮"区域显示提示信息'
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }